import React from 'react';
import { Camera } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-400 py-16 mt-auto">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-b border-slate-800 pb-12">
          
          <div className="col-span-1 md:col-span-5 space-y-6">
            <div className="flex items-center space-x-3">
               <div className="bg-indigo-500/20 p-2.5 rounded-xl">
                 <Camera className="text-indigo-400 h-6 w-6 stroke-[2.5]" />
               </div>
               <span className="text-2xl font-black text-white tracking-tight">
                Pass-Photo
               </span>
            </div>
            <p className="text-sm max-w-sm leading-relaxed text-slate-500">
              The fastest way to generate passport-sized photos using cutting-edge AI. Enhance, remove background, and format prints in seconds. No editing software required.
            </p>
          </div>
          
          <div className="col-span-1 md:col-span-3 space-y-5">
            <h4 className="text-white text-sm font-bold uppercase tracking-widest">Features</h4>
            <ul className="space-y-3 font-medium text-sm">
              <li><button onClick={() => window.scrollTo(0,0)} className="hover:text-indigo-400 transition-colors">Background Removal</button></li>
              <li><button onClick={() => window.scrollTo(0,0)} className="hover:text-indigo-400 transition-colors">Smart Photo Enhance</button></li>
              <li><button onClick={() => window.scrollTo(0,0)} className="hover:text-indigo-400 transition-colors">Standard Print Layouts</button></li>
              <li><button onClick={() => window.scrollTo(0,0)} className="hover:text-indigo-400 transition-colors">HD Photo Generation</button></li>
            </ul>
          </div>
          
          <div className="col-span-1 md:col-span-4 space-y-5">
            <h4 className="text-white text-sm font-bold uppercase tracking-widest">Stay Updated</h4>
            <p className="text-sm text-slate-500">Join our newsletter to receive the latest updates.</p>
            <div className="flex gap-2">
               <input type="email" placeholder="Your email address" className="bg-slate-900 border border-slate-800 focus:border-indigo-500 text-sm px-4 py-2.5 rounded-lg outline-none w-full text-white placeholder-slate-600 focus:ring-1 focus:ring-indigo-500/50 transition-all" />
               <button className="bg-indigo-600 hover:bg-indigo-500 text-white font-semibold px-4 py-2.5 rounded-lg transition-colors shadow-[0_0_15px_rgba(79,70,229,0.4)]">Sub</button>
            </div>
          </div>

        </div>
        
        <div className="pt-8 text-sm flex flex-col md:flex-row justify-between items-center text-center text-slate-600 font-medium space-y-4 md:space-y-0">
          <p className="flex-1 md:text-left">&copy; {new Date().getFullYear()} Pass-Photo. All rights reserved.</p>
          <p className="flex-1 text-center">
            Developed by <span className="text-indigo-400 font-bold tracking-wider hover:text-indigo-300 transition-colors cursor-pointer">DarkCoder</span>
          </p>
          <div className="flex-1 flex justify-center md:justify-end space-x-6">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
  <a
  href="mailto:darkcoder.studio@gmail.com?subject=Support%20Request&body=Hello%2C%20I%20need%20help..."
  className="hover:text-white transition-colors">
  Contact Us
 </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
